import styled from 'styled-components';
import theme from '../../theme';

export const Container = styled.section`
  display: block;
  background: ${theme.colors.cardB1};
  padding-bottom: 0px;
`;

export const Content = styled.div`  
  justify-content: flex-start;
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
`;

export const Title = styled.span`
  color: ${theme.colors.title};
  font-size:  14px;
  font-weight: bold;
  font-style: normal;
  text-transform: uppercase;
  @media (min-width: 768px) {
    font-size: 20px;
  }
`;

export const SubTitle = styled.span`
  color: ${theme.colors.title};
  margin-top: 16px;
  font-size:  14px;
  font-weight: bold;
  font-style: normal;
  text-transform: uppercase;
  @media (min-width: 768px) {
    font-size: 18px;
  }
`;
export const Text = styled.span`
 color: ${theme.colors.title};
  font-size:  13px;
  font-weight: 500;
  font-style: normal;
  padding-top: 10px;
  padding-bottom: 10px;
  @media (min-width: 768px) {
    font-size: 16px;
  }
`;

export const Button = styled.button`
  background-color: ${theme.colors.graph};
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 18px;
  padding-left: 18px;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  border-color: ${theme.colors.graph};
  margin-right: 80px;
  margin-left: 80px;
  margin-top: 10px;
  margin-bottom: 10px;
  cursor: pointer;
`;

export const ButtonText = styled.span`
  color: ${theme.colors.title};
  font-weight: 600;
  text-transform: uppercase;
`;

export const Input = styled.input`
  border-radius: 5px;
  height: 40px;
  padding: 0 10px;
  font-size: 17px;
  text-transform: uppercase;
`;

export const ErrorMessage = styled.div`
  color: ${theme.colors.redAlert};
`;

export const Card = styled.img`
  width: 100%;
  border-radius: 10px;
  background-color: ${theme.colors.cardB4};
`;
